class DZModelWikiLabel{
    id = ""
    name = ""
}
export default DZModelWikiLabel
